import './Content.scss';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import ContentInfo from './ContentInfo';
import ContentResource from './ContentResource';
import { getProvidersProps } from 'dhub-config';
import PropTypes from 'prop-types';
import React from 'react';

const providersUrls = getProvidersProps(['urls']);

/**
 * This component fetches the resources data and renders a container with an instance of ContentInfo (request and response info) and
 * ContentResource (resource info and media).
 */
class Content extends React.Component {
    static propTypes = {
        authToken: PropTypes.string.isRequired
    }

    constructor(props) {
        super(props);

        this.state = {
            error: null,
            fetching: false,
            media: {},
            min: DOWNLOAD_HUB_REDUCER_THRESHOLD,
            page: 0,
            resources: [],
            type: ''
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.filterMedia = this.filterMedia.bind(this);
    }


    componentDidMount() {
        window.scrollTo(0, 0);
        this.fetchData();
    }

    handleInputChange(event) {
        this.setState({ [event.target.name]: event.target.name === 'type' ? event.target.value : parseInt(event.target.value, 10) });
    }

    handleSubmit(event) {
        event.preventDefault();

        window.scrollTo(0, 0);
        this.fetchData();
    }

    fetchData() {
        this.setState({ error: null, fetching: true });

        fetch(`${DOWNLOAD_HUB_REDUCER_SERVER_URL}${DOWNLOAD_HUB_REDUCER_SERVER_API.resources}`
        + `${this.state.min ? `?min=${encodeURIComponent(this.state.min)}` : ''}`
        + `${this.state.page ? `&page=${encodeURIComponent(this.state.page)}` : ''}`
        + `${this.state.type ? `&type=${encodeURIComponent(this.state.type)}` : ''}`, {
            headers: {
                Authorization: `Bearer ${this.props.authToken}`
            },
            timeout: DOWNLOAD_HUB_REDUCER_REQ_TIMEOUT
        }).then((res) => res.json()).then((res) => {
            const { media, resources } = res;
            return this.setState({ fetching: false, media, resources });
        }).catch((error) => {
            this.setState({ error, fetching: false });
        });
    }

    filterMedia(allowed) {
        return Object.keys(this.state.media).filter((key) => allowed.includes(parseInt(key, 10)))
            .reduce((acc, key) => [...acc, this.state.media[key]], []);
    }


    render() {
        const config = (({ min, page, type }) => ({ min, page, type }))(this.state);
        const counter = (({ media, resources }) => ({ media: Object.keys(media).length, resources: resources.length }))(this.state);

        return (
            <div className='content'>
                {this.state.fetching && <AiOutlineLoading3Quarters />}

                <ContentInfo config={config} counter={counter} onInputChange={this.handleInputChange} onSubmit={this.handleSubmit} />

                {this.state.error && <p className='state'>{'Error fetching the data'}</p>}

                {
                    this.state.resources.length
                        ? (
                            <>
                                {this.state.resources.map(({ related, ...resource }) => (
                                    <ContentResource key={`${providersUrls[resource.origin][0]}${resource.url}`}
                                        authToken={this.props.authToken} correctMedia={related.manual}
                                        media={this.filterMedia([...related.manual, ...related.auto])} resource={resource} />
                                ))}

                                <button type='button' onClick={this.handleSubmit}>{'Refresh'}</button>
                            </>
                        )
                        : !this.state.fetching && <p className='state'>{'No Resources'}</p>
                }
            </div>
        );
    }
}

export default Content;